import Keycloak from 'keycloak-js';

const keycloak = typeof window !== 'undefined'
  ? new Keycloak({
      url: process.env.NEXT_PUBLIC_KEYCLOAK_URL || 'http://localhost:8080',
      realm: process.env.NEXT_PUBLIC_KEYCLOAK_REALM || 'scalesutra',
      clientId: process.env.NEXT_PUBLIC_KEYCLOAK_CLIENT_ID || 'scalesutra-app',
    })
  : null;

export default keycloak;
